module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"prop-detail main-picture\">\r\n	<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n		<div class=\"col-md-12 subsection nopadding-r\">\r\n			<label class=\"prop-sublabel label-35\">Image</label> \r\n			<div>\r\n				<select id=\"assetSelect\" name=\"asset\" style=\"width: 100%;\">\r\n					<option value=\"none\">None</option>\r\n				</select>\r\n			</div>\r\n		</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-1\">\r\n			<input type=\"checkbox\" name=\"maintainAspectRatio\">\r\n		</div>\r\n		<div class=\"col-md-10 nopadding-l\" style=\"padding-top: 3px;\">Maintain aspect ratio</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-1\">\r\n			<input type=\"checkbox\" name=\"stretch\">\r\n		</div>\r\n		<div class=\"col-md-10 nopadding-l\" style=\"padding-top: 3px;\">Stretch</div>\r\n	</div>\r\n	<div class=\"row\">\r\n        <div class=\"prop-header\"><span class=\"prop-label\">Print Quality</span></div>\r\n        <select name=\"printQuality\" id=\"printQuality\">\r\n            <option value=\"regular\">Regular</option>\r\n			<option value=\"good\">Good</option>\r\n            <option value=\"high\">High</option>\r\n            <option value=\"vhigh\">Very High</option>\r\n        </select>\r\n    </div>\r\n</div>")
  }
  return __output;

}